import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RatingComponent.css';
import { Progress } from 'reactstrap';

class RatingComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool,
    qAndAInfo: PropTypes.shape({
      question: PropTypes.string.isRequired,
      questionType: PropTypes.string.isRequired,
      dateAsked: PropTypes.string,
      numberOfResponses: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      avgRating: PropTypes.number,
      responses: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string.isRequired,
          numberOfResponses: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          answererEmails: PropTypes.array
        })
      ).isRequired,
      totalQuestions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      uniqueRegistrantEmailsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      currentQuestionIndex: PropTypes.number.isRequired
    })
  };

  render() {
    const qAndAInfo = this.props.qAndAInfo;
    const isBig = this.props.isBig;
    const { t } = this.context;
    return (
      <div className="ratingComponent">
        <div className="qAndACard">
          <div className="qAndAHeader">
            <div>
              <span className="qAndACount">
                {t('engagement.questionsCount', {
                  currentQuestionIndex: qAndAInfo.currentQuestionIndex,
                  totalQuestions: qAndAInfo.totalQuestions
                })}
              </span>
              {isBig && <span> {qAndAInfo.question} </span>}
            </div>
            <div>
              {t('engagement.numberOfRegistrantsResponded', {
                numberOfRegistrantsResponded: qAndAInfo.uniqueRegistrantEmailsCount
              })}
            </div>
          </div>
          <div className="qAndASubHeader">
            {!isBig && <div className="mobileQuestionAttribute"> {qAndAInfo.question} </div>}
            <span className="mobileQuestionTypeAttribute">{t('engagement.ratingQuestionType')}</span>
            {isBig && (
              <span className="subHeaderContent">{t('engagement.avgRating', { avgRating: qAndAInfo.avgRating })}</span>
            )}
          </div>

          <div className="progressBarContent">{this.displayProgressBar(qAndAInfo)}</div>
          {!isBig && (
            <span className="mobileViewAvgRating">{t('engagement.avgRating', { avgRating: qAndAInfo.avgRating })}</span>
          )}
        </div>
      </div>
    );
  }

  displayProgressBar = qAndAInfo => {
    const { t } = this.context;
    const sortedQAndAInfo = qAndAInfo.responses.sort((a, b) => a.text - b.text);
    return sortedQAndAInfo.map((item, index) => (
      <div className="progressBarAlignment" key={index}>
        <div className="mobileResponseView">
          {t('engagement.numberOfResponses', { numberOfResponses: item.numberOfResponses })}
        </div>
        <div className="textAlignment"> {item.text}</div>
        <Progress value={item.percentage} className="vertical" barClassName="customProgressBarVertical" />
        <div className="percentAlignment">{item.percentage}%</div>
      </div>
    ));
  };
}

export default RatingComponent;



// WEBPACK FOOTER //
// ./src/Components/RatingComponent/RatingComponent.js